export default __webpack_public_path__ + "static/media/gallery_09.ede4278b.jpg";